import { render, staticRenderFns } from "./RandomWordField.vue?vue&type=template&id=52325048"
import script from "./RandomWordField.vue?vue&type=script&lang=ts"
export * from "./RandomWordField.vue?vue&type=script&lang=ts"
import style0 from "./RandomWordField.vue?vue&type=style&index=0&id=52325048&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports